import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './filter-tags.scss.js';
import { getStyleClassNames } from '../../utilities/constants/styles.constants.js';

class FilterTags extends s {
    constructor() {
        super(...arguments);
        this.tagNames = [];
        this.additionalClasses = '';
        this.marginBottom = '';
        this.marginTop = '';
        this.justifyContent = 'center';
    }
    render() {
        const containerClassNames = getStyleClassNames({
            marginBottom: this.marginBottom,
            marginTop: this.marginTop,
            additionalClasses: `${this.additionalClasses}`,
        });
        const justifyContentTag = `justify-content: ${this.justifyContent};`;
        return x `<div class="tag-component ${containerClassNames}"><div class="title"><slot name="title"></slot></div><div class="tagContainer" style="${justifyContentTag}"><slot></slot></div></div>`;
    }
}
FilterTags.styles = css_248z;
__decorate([
    n({ type: Array })
], FilterTags.prototype, "tagNames", void 0);
__decorate([
    n({ type: String })
], FilterTags.prototype, "additionalClasses", void 0);
__decorate([
    n({ type: String })
], FilterTags.prototype, "marginBottom", void 0);
__decorate([
    n({ type: String })
], FilterTags.prototype, "marginTop", void 0);
__decorate([
    n({ type: String })
], FilterTags.prototype, "justifyContent", void 0);
customElements.define('filter-tags', FilterTags);

export { FilterTags };
